module.exports = __webpack_public_path__ + "img/gc-logo.28c2b3f9.png";